// extracted by mini-css-extract-plugin
module.exports = {"cosagoFormWithControlledNavigation":"FormWithControlledNavigation_cosagoFormWithControlledNavigation__fLQu7"};